import React, {useEffect, useMemo, useState} from 'react'
import {useSelector} from "react-redux";
import Calendar from "react-calendar";
import moment from "moment";
import {showingData, vehiclesColumnsData} from "./const";
import {VehicleTableRow} from "../../Components/VehicleTableRow";
import {CustomSelect} from "../../UI/Select";
import AutoSuggestInput from "../../Components/AutoSuggestInput";
import Header from "../../Components/Header";
import useGetJobFormsApi from "../../Global/Api/Jobs/getJobForms";
import {useDebounce} from "../../Global/Hooks/useDebounce";
import JobFormModal from "../../Components/Modals/jobFormModal";
import {Paginate} from "../../Components/Paginate";
import 'react-calendar/dist/Calendar.css';
import './index.scss'
// import {useGetJobFormsMutation} from "../../Store/Builder/jobs.api";
// import Pagination from "../../Components/Pagination";
// import {setActiveJobStatus, setCurrentPage, setSearchValue} from "../../Store/Slice/jobsSlice";
// import axios from "axios";

export default function Vehicles() {
  const [vehicleColumns, setVehicleColumns] = useState(vehiclesColumnsData)
  const [orderDirection, setOrderDirection] = useState(false)
  const [showFormDetails, setShowFormDetails] = useState(false)
  const [dateValue, setDateValue] = useState(null);
  const [search, setSearch] = useState('')
  const [showCalendar, setShowCalendar] = useState(false)
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(showingData[0])
  const [customer, setCustomer] = useState([])
  const [address, setAddress] = useState('');

  const [columnFilter, setColumnFilter] = useState(false)
  const [order, setOrder] = useState(null)
  const getVehicles = useGetJobFormsApi();
  const {jobForms} = useSelector((state) => state?.rootReducer.jobsSlice);
  const [formJobIobId, setFormJobIobId] = useState(null);

  const debouncedSearchValue = useDebounce(search, 300);

  // Reset to page 1 when any filter changes (but not when page itself changes)
  useEffect(() => {
    setPage(1);
  }, [debouncedSearchValue, dateValue, perPage, order, orderDirection])

  // Fetch data whenever page or any filter/address changes
  useEffect(() => {
    if (address && address?.address !== undefined && !address?.lat) return;
    const formattedParams = formatParams();
    getVehicles.get(formattedParams)
  }, [debouncedSearchValue, dateValue, perPage, order, orderDirection, page, address])

  useEffect(() => {
    setShowCalendar(false)
    return window.addEventListener('click', (e) => {
      if (e.target.closest('.dashboard__calendar') === null && e.target.closest('.react-calendar') === null && e.target.closest('.react-calendar__year-view__months') === null) {
        setShowCalendar(false)
      }
    })
  }, [])

  const formatParams = () => {
    const params = new URLSearchParams();
    if (debouncedSearchValue.length > 0) params.append('search', debouncedSearchValue);
    if (dateValue) params.append('date', moment(dateValue[0]).format('MM-DD-YYYY'));
    if (dateValue) params.append('end_date', moment(dateValue[1]).format('MM-DD-YYYY'));
    if (address?.lat) params.append('location[lat]', address.lat);
    if (address?.lon) params.append('location[lon]', address.lon);
    if (order) {
      params.append('order', String(order));
      params.append('order_direction', orderDirection ? 'desc' : 'asc');
    }
    params.append('page', String(page));
    if (perPage?.value && perPage?.value !== '') params.append('perPage', perPage.value);
    return params
  }
  const downloadExcel = () => {
    const formattedParams = formatParams();
    const link = document.querySelector('#downloadExcel')

    getVehicles.downloadExcel(formattedParams, link);
  }

  const renderVehiclesColumns =
    vehicleColumns.map(column => (
      <div onClick={() => {
        if (column?.filter) {
          if (order === column?.id) {
            setOrderDirection(!orderDirection)
          } else {
            setOrder(column?.id)
            setOrderDirection(true)
          }
        }
      }} className={`dashboard__vehicles-head-item ${!column.show ? 'hide' : ''}`} key={column.name}>
        <span>{column.name}</span>{column.filter &&
      <img src="/assets/icons/filter.svg" alt="filter"/>}</div>
    ))

  const renderColumnsElem = useMemo(() => (
    vehicleColumns?.map((column, index) => (
      <div key={index} className={`dashboard__columns-elem ${column.show ? 'hide' : ''}`}
           onClick={() => {
             setVehicleColumns(vehicleColumns?.map((item, idx) => {
               if (item.id === column.id) {
                 column.show = !column.show
               }
               return item
             }))
           }}
      >
        {column.name}
      </div>
    ))
  ), [vehicleColumns])

  const renderColumnsDropdown = () => {
    return (
      <div className="dashboard__columns">
        {renderColumnsElem}
      </div>
    )
  }

  const renderVehicleTableRow = useMemo(() => (
    jobForms?.data?.map((item, index) => (
      <VehicleTableRow item={item} vehicleColumns={vehicleColumns} key={item?.id || item?.job_id || index}
                       setShowFormDetails={setShowFormDetails}
                       setFormJobIobId={setFormJobIobId} />
    ))
  ), [jobForms?.data, vehicleColumns])


  return (
    <>
      <JobFormModal
        formJobIobId={formJobIobId}
        setShowFormDetails={setShowFormDetails}
        showFormDetails={showFormDetails}
      />
    <Header title={'My Vehicles'}/>
    <div className='vehicles'>
      <div className="dashboard__filters">
        {showCalendar && <Calendar  selectRange={true} calendarType={'US'} onChange={(date) => {
          // setIsLoader(true)
          setDateValue(date)
        }} value={dateValue}/>}
        <div className="dashboard__search">
          <span><img src="/assets/icons/search.svg" alt="search"/></span>
          <input value={search} placeholder="Search by VIN, serial, PO or label" onChange={(e) => {
            setSearch(e.target.value)
            // api.getData(`customers?filter=${e.target.value}`, localStorage.getItem('userToken'))
            //   .then(res => {
            //     setCustomer(res.data)
            //   })
          }} type="text"/>
          {
            customer?.length > 0 && search?.length > 0 && <div className="dashboard__search-results">
              {
                customer?.map(item => (
                  <div onClick={() => {
                    setSearch(item?.name)
                    setCustomer([])
                  }} className="dashboard__search-item">{item?.name}</div>
                ))
              }
            </div>
          }
        </div>
        <div className="dashboard__filters-right">
          <div className='dashboard__address'>
            <AutoSuggestInput
              address={address?.address ?? ''}
              handleAddressChange={(e) => {
                setAddress(e)
              }}
              placeholder="Location"
              className=""
            />
          </div>
          <div onClick={() => {
            setShowCalendar(!showCalendar)
          }} className='dashboard__calendar'>
            <div className="dashboard__calendar-field">
              {dateValue === null && <p className="dashboard__calendar-placeholder">Date</p>}
              {dateValue !== null && <p className="dashboard__calendar-text">{dateValue[0].toString().slice(0, 15)} - {dateValue[1].toString().slice(0, 15)}</p>}
              <div className="icons_filter">
                {dateValue && <img onClick={() => {
                  setDateValue(null)
                }} className="icons_filter_close" src="/assets/icons/close.svg" alt=""/>}
                <img src="/assets/icons/calendar.svg" alt="calendar"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard__content">
        <div className="dashboard__content-head">
          <div className="dashboard__head-left">
            <span>Showing:</span>
            <div className="dashboard__head-select">
              <CustomSelect
                options={showingData}
                selected={perPage}
                handleSelect={(e) => {
                  setPerPage(e ?? null)
                }}
                isClearable={false}
              />
            </div>
          </div>
          <div className="dashboard__head-right">
            {columnFilter && renderColumnsDropdown()}
            <div className="dashboard__head-btn" onClick={() => setColumnFilter(!columnFilter)}>
              <img src="/assets/icons/columns.svg" alt="columns"/>
              <span>Columns</span>
            </div>
            <a target="_blank" id="downloadExcel">
              <div onClick={async () => {
                if (jobForms.data?.length > 0) {
                  await downloadExcel()
                }
              }}
                   className={`dashboard__head-btn dashboard__head-btn_blue ${jobForms.data?.length === 0 ? 'dis_btn' : ''}`}>
                <img src="/assets/icons/excel.svg" alt="excel"/>
                <span>Export to excel</span>
              </div>
            </a>
          </div>
        </div>
          <div className="dashboard__table-wrapper">
            {jobForms.data?.length === 0 ? (
              <div className='emmpty'>
                <div>
                  <img src="/assets/images/empty-vehicles.svg" alt=""/>
                </div>
                <p className="technicians-empty-text">No Completed Jobs</p>
              </div>
            ) : (
              <div className="dashboard__vehicles">
                <div className="dashboard__vehicles-head">
                  {renderVehiclesColumns}
                </div>
                <div className="dashboard__vehicles-item">
                  {
                    renderVehicleTableRow
                  }
                </div>
              </div>
            )}
          </div>
        {jobForms?.totalPage > 1 && (
          <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
            <Paginate currentPage={page} setCurrentPage={setPage} pageCount={jobForms?.totalPage}/>
          </div>
        )}
      </div>
    </div>
    </>
  )
}
